<template>
  <div class="container">
    <mosaic-style>
      <template v-for="(item, index) in fetchData">
        <block
          :slot="resolveMosaic(index)"
          :data="item"
          :id="id"
          :css="block.settings.style"
          :sectionId="block.id"
          :settings="block.settings"
          :uiBlockComponent="block.settings.component"
          :sectionTextColor="block.titleColor"
          :theme="theme"
        >
        </block>
      </template>
    </mosaic-style>
  </div>
</template>
<script>
  import section from '@fremcast/section/mixins/section';
  import video from '@fremcast/section/mixins/videos';
  import presentation from '@fremcast/section/mixins/presentation';
  import card from '@fremcast/section/mixins/card';
  export default {
    mixins: [
      section,
      video,
      presentation,
      card
    ],
    methods: {
      resolveMosaic(index) {
        const max = 6;
        if (index > max) {
          return 1;
        }
        const val = max - index;
        return val;
      }
    },
    components: {
      Block: () => import("./Block"),
      MosaicStyle: () => import("./MosaicStyle")
    }
  }
</script>